import { render, staticRenderFns } from "./CampaignDetailsOverview.vue?vue&type=template&id=0cd05372&scoped=true&"
import script from "./CampaignDetailsOverview.vue?vue&type=script&lang=js&"
export * from "./CampaignDetailsOverview.vue?vue&type=script&lang=js&"
import style0 from "./CampaignDetailsOverview.vue?vue&type=style&index=0&id=0cd05372&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd05372",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VFlex,
  VIcon,
  VLayout,
  VProgressCircular,
  VSelect,
  VSpacer,
})
